const apiConstants = {
  URLS: {
    PAYMENT: "payments",
    SERVICES: "services",
    OTP: "otp",
    AUTHX: "authx"
  },
  ENTITY_TYPE_ID: 1,
  PAYMENT_METHOD_ID: 1,
  TRANSACTION_TYPES: [
    {
      name: "Credit",
      value: 1
    },
    {
      name: "Debit",
      value: 0
    }
  ],
  TRANSACTION_ACTIVITIES: [
    {
      name: "Charge",
      value: "charge"
    },
    {
      name: "Wallet Funding",
      value: "wallet_funding"
    }
  ],
  GLOBAL_STATUS: {
    ACTIVE: 1,
    INACTIVE: 2,
    REMOVED: 3,
    PASSWORD_RESET: 4,
    NEW: 5,
    UNVERIFIED: 6,
    PENDING: 7,
    VERIFIED: 8,
    AWAITING_FULL_ACCESS: 9
  },

  GLOBAL_STATUS_LABEL: {
    1: "Active",
    2: "Inactive",
    3: "Removed",
    4: "Password Reset",
    5: "New",
    6: "Unverified",
    7: "Pending",
    8: "Verified",
    9: "Awaiting Full Access"
  },

  IDENTITY_TYPES: [
    {
      name: "BVN Advanced",
      value: "bvn/advanced",
      idLabel: "ID",
      placeholder: "Enter ID No"
    },
    {
      name: "NIN",
      value: "nin",
      idLabel: "ID",
      placeholder: "Enter ID No"
    },
    {
      name: "Phone Number",
      value: "nin/phone",
      idLabel: "Phone Number (Format: 2348123456789)",
      placeholder: "Enter Phone Number"
    },
    {
      name: "Driver's License",
      value: "drivers/licenses",
      idLabel: "ID",
      placeholder: "Enter ID No"
    },
    {
      name: "Passport",
      value: "passport/nigeria",
      idLabel: "ID",
      placeholder: "Enter ID No"
    },
    {
      name: "TIN",
      value: "tin",
      idLabel: "ID (Format: 1234-5678)",
      placeholder: "Enter ID No"
    },
    {
      name: "VNIN",
      value: "vnin",
      idLabel: "ID",
      placeholder: "Enter ID No"
    }
  ],
  IDENTIFICATION_SYSTEM: {
    INDIVIDUAL: 1,
    CORPORATE: 2
  },
  SERVICE_IDS: {
    VERIFICATION: 1
  },
  MIN_ALLOWED_DIRECTORS_COUNT: 1,
  MAX_ALLOWED_DIRECTORS_COUNT: 3,

  SLOT_TYPES: [
    {
      name: "Date",
      value: "date"
    },
    {
      name: "Month",
      value: "month"
    },
    {
      name: "Year",
      value: "year"
    }
  ],
  USER_TYPES: {
    NORMAL: 3
  },
  NO_ACCESS_CODES: ["ACCESS_DENIED", "NO_AUTH"],
  TEXT_TYPE_IDENTIFIER: 1,
  COLLECTION_TYPE_IDENTIFIER: 1,
  SOCIAL_AUTH_TYPES: {
    GOOGLE: {
      NAME: "Google",
      VALUE: "google"
    },
    FACEBOOK: {
      NAME: "Facebook",
      VALUE: "facebook"
    }
  }
};

export default apiConstants;
